

const ENV = process.env.REACT_APP_ENV;
const config = {
    DEV: {
      apiMarketplaceBaseUrl: "http://localhost:8082/",
      staticAssetsUrl: "https://assets.airtel.in/static-assets/api-marketplace/images/"
    },
    PROD: {
      apiMarketplaceBaseUrl: "https://m2m.airteliot.co.in/",
      staticAssetsUrl: "https://assets.airtel.in/static-assets/api-marketplace/images/"
    },
    QA: {
      apiMarketplaceBaseUrl: "https://api-marketplace.apps.n2ocp-tclus-01.india.airtel.itm/",
      staticAssetsUrl: "https://assets.airtel.in/static-assets/api-marketplace/images/"
      
    }
  };
  
  export default config[ENV];

